import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

export default function CardProductSkeleton() {
  return (
    <Card className='flex h-full flex-col border-none p-0 shadow-none'>
      <CardHeader className='p-3'>
        <div className='flex items-start justify-between'>
          <Skeleton className='h-4 w-24' />
        </div>
      </CardHeader>
      <CardContent className='flex h-full flex-col justify-between p-3 pb-1 pt-0'>
        <div>
          <Skeleton className='h-[250px] w-full' />
          <Skeleton className='mt-3 h-4 w-[120px]' />
        </div>
        <div>
          <div className='py-4'>
            <Skeleton className='h-4 w-[120px]' />
          </div>
          <div className='flex items-center gap-x-2 py-4'>
            <Skeleton className='h-5 w-5' />
            <Skeleton className='mt-0.5 h-4 w-[120px]' />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
